import { yup } from '@framework/validation/initYup.ts';
import { fromPairs, merge } from 'lodash';
import { FormBuilderMetaFlags } from '../../../../../validator/form-builder/flags/FormBuilderMetaFlags.ts';
import { type ICreateWidgetFormSchemaInput } from '../../../IWidgetType.ts';
import { getDatatypeOutputSchema } from '../../common/async-widgets/getDatatypeOutputSchema.ts';
import {
  ButtonActionType,
  type IButtonActionExecAsyncService,
} from './actions/IButtonAction.ts';
import { getActionDataObjectName } from './getActionDataObjectName.ts';
import { type IButtonWidget } from './IButtonWidget.ts';

export function createButtonWidgetSchema(
  input: ICreateWidgetFormSchemaInput<IButtonWidget>,
) {
  const { widget } = input;

  const serviceActions =
    widget.actions
      ?.map((action, index) => ({ action, index }))
      ?.filter(
        (a): a is { action: IButtonActionExecAsyncService; index: number } =>
          a.action.type === ButtonActionType.ExecAsyncService,
      ) ?? [];

  if (serviceActions.length === 0) return {};

  const serviceActionSchema = serviceActions.map(action => {
    const outputs = action.action.outputs ?? [];
    return {
      [getActionDataObjectName(widget, action.index)]: yup
        .object(
          fromPairs(
            outputs.map(output => [
              output.name,
              getDatatypeOutputSchema(output.type),
            ]),
          ),
        )
        .formBuilderFlags(
          FormBuilderMetaFlags.SkipDefaultValue,
          FormBuilderMetaFlags.SkipValidationRules,
        )
        .notRequired(),
    };
  });

  return merge({}, ...serviceActionSchema);
}
